const HBBTV_KEYS = {
    GREEN: 'GREEN',
    YELLOW: 'YELLOW',
    BLUE: 'BLUE',
    RED: 'RED',
    NAVIGATION: 'NAVIGATION',
    NUMERIC: 'NUMERIC',
    VCR: 'VCR',
    SCROLL: 'SCROLL',
    INFO: 'INFO',
    ALPHA: 'ALPHA',
    OTHER: 'OTHER'
};

export { HBBTV_KEYS }